import { createContext } from "react";
const RealTimeContext = createContext({});
export { RealTimeContext };
